import { ca } from '@cian/analytics';
import { TAnalyticsOfferStatus, IAnalyticsProduct, IAnalyticsExtraOfferIds } from '../../../types/analytics';
import { EServiceId } from '../../../types/reducers/publishTerms';
const debounce = require('lodash/debounce');

interface ITrackBetTypingParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  analyticsExtraOfferIds: IAnalyticsExtraOfferIds;
  selectedServiceId: EServiceId | null;
  currentBet: number | null;
  offerPosition: number | null;
  page: number | null;
}

export const trackBetTyping = debounce((params: ITrackBetTypingParams) => {
  const { analyticsOfferStatus, analyticsProduct, selectedServiceId, offerPosition, page, currentBet } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_type_bid',
    label: currentBet,
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        ...params.analyticsExtraOfferIds,
        type: 'fvu_newest_webview',
        vas: selectedServiceId,
        position: offerPosition,
        page_number: page,
      },
    },
  });
}, 1000);

interface ITrackBetChangeParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  analyticsExtraOfferIds: IAnalyticsExtraOfferIds;
  sign: string;
  selectedServiceId: EServiceId | null;
  currentBet: number | null;
  offerPosition: number | null;
  page: number | null;
}

export const trackBetChange = debounce((params: ITrackBetChangeParams) => {
  const {
    analyticsOfferStatus,
    analyticsProduct,
    sign,
    selectedServiceId,
    offerPosition,
    page,
    currentBet,
    analyticsExtraOfferIds,
  } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_change_bid',
    label: sign,
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        ...analyticsExtraOfferIds,
        type: 'fvu_newest_webview',
        bid: currentBet,
        vas: selectedServiceId,
        position: offerPosition,
        page_number: page,
      },
    },
  });
}, 1000);
